import React from 'react';

import { useDoesCarrierProvideRateByServiceId } from '../../../hooks/use-does-carrier-provide-rate-by-serviceId';

import { useFulfillmentPlannerContext } from '../../context';

import { RateWarningTooltip } from './rate-warning-tooltip';

export const useDoesCarrierProvideRate = () => {
  const { serviceIdAndSellerLabelProviderId } = useFulfillmentPlannerContext();
  return useDoesCarrierProvideRateByServiceId(serviceIdAndSellerLabelProviderId?.serviceId);
};

export const OrderRateWarningTooltip = () => {
  const carrierProvidesRate = useDoesCarrierProvideRate();

  if (carrierProvidesRate) {
    return null;
  }

  return <RateWarningTooltip />;
};
